import { render, staticRenderFns } from "./MessagingSettingsPanel.vue?vue&type=template&id=5fe828b4"
import script from "./MessagingSettingsPanel.vue?vue&type=script&lang=js"
export * from "./MessagingSettingsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports